import React from "react";
import { Box } from "grid-styled";
import Modal from "./Modal";
import UploadEditForm from "./UploadEditForm";

class UploadsModal extends React.Component {
  render() {
    const { job, uploads, dropTypes, start, cancel, cancelAll } = this.props;
    const currentUpload = uploads[0];

    const startUpload = values => {
      start({
        ...currentUpload,
        ...values
      });
    };

    const startAllUploads = values => {
      uploads.forEach(upload => {
        start({
          ...upload,
          ...values,
          name: upload.name
        });
      });
    };

    // Set title
    let title = "Upload a file?";
    if (uploads.length > 1) {
      // Include counter if more than one file being uploaded
      title = title + ` (and ${uploads.length - 1} more)`;
    }

    return (
      <Modal
        isOpen={uploads.length > 0}
        close={cancelAll}
        title={title}
        style={{ maxWidth: 650 }}
      >
        <Box p={2}>
          {currentUpload && (
            <UploadEditForm
              job={job}
              upload={currentUpload}
              dropTypes={dropTypes}
              cancel={() => cancel(currentUpload.id)}
              cancelAll={uploads.length > 1 && (() => cancelAll())}
              onSubmitAll={uploads.length > 1 && (() => startAllUploads())}
              onSubmit={startUpload}
            />
          )}
        </Box>
      </Modal>
    );
  }
}

export default UploadsModal;



// WEBPACK FOOTER //
// ./src/components/UploadsModal.js